import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLatestLoad } from '../../hooks/useLatestLoad';
import { fetchSalesReport } from '../adminApi';
import { Skeleton } from '../../ui/Skeleton';
import { money } from '../../core/format/currency';
import { change, changeLabel } from './salesPeriods';
import { monthStart, today } from '../../core/format/dates';
import type { RequestOptions } from '../../core/types/backend';

/** Op het overzicht: omzet van de webshop deze maand tot nu toe, met het verschil. Klik voor de details. */
export function RevenueTile() {
  const load = useCallback((opts: RequestOptions) => {
    const to = today();
    return fetchSalesReport(monthStart(to), to, 'day', undefined, opts);
  }, []);
  const {
    data,
    status
  } = useLatestLoad(load);
  const pct = data ? change(data.totals.revenueExVatCents, data.previous.revenueExVatCents) : null;
  return <Link to="/be/omzet?periode=maand" className="group block rounded-lg border border-line bg-white p-4 transition-colors duration-150 ease-soft hover:border-ink/30 sm:p-6" data-id="element-3715" data-mp="cvhjr0ke37zk">
      <span className="flex items-center justify-between text-[13px] text-muted" data-id="element-3716" data-mp="33lf722poiio4">
        Omzet deze maand · webshop
        <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-soft group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-3717" data-mp="37kxryyhi2tqy" />
      </span>
      {status === 'error' && !data ? <span className="mt-2 block text-[14px] text-muted" data-id="element-3718" data-mp="3he4ri2pk7fj4">Kon niet laden. Open het omzetscherm.</span> : !data ? <span className="mt-2 block" role="status" aria-label="Omzet laden" data-id="element-3719" data-mp="3ra83e0a7qsj9">
          <Skeleton className="h-9 w-32 rounded" data-id="element-3720" data-mp="3r83v765a77d6" />
        </span> : <>
          <span className="mt-1 block font-display text-[2rem] font-light leading-tight tabular-nums text-ink" data-id="element-3721" data-mp="3vb0devqwt1gl">{money(data.totals.revenueExVatCents)}</span>
          <span className="block text-[13px] text-muted" data-id="element-3722" data-mp="20x0m7r1iio3m">
            {pct === null ? 'excl. btw · vorige maand nog niets' : <>
                excl. btw · <span className={pct >= 0 ? 'text-sage' : 'text-clay'} data-id="element-3723" data-mp="2za4ut758ee3u">{changeLabel(pct)}</span> t.o.v. vorige maand
              </>}
          </span>
        </>}
    </Link>;
}